import { images } from ".";

const partners = [
    images.partner1,
    images.partner2,
    images.partner3,
    images.partner4,
    images.partner5,
    images.partner6,
    images.partner7,
    images.partner8,
    images.partner9,
];

export default partners;